// extracted by mini-css-extract-plugin
export var news_item = "News-module--news_item--8zKng";